import RoutePage from "~/components/about-us/AboutUsPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/about-us")({
  head: async () =>
    (await import("~/utils/liveSeoHead")).headFromLiveSeo("/about-us"),
  component: RoutePage,
});
